import React from "react"
import { Link } from "gatsby"
import PropTypes from "prop-types"
import Layout from "../components/layout"
import Hero from "../components/home-hero"
import Tilt from "react-parallax-tilt"

const Menu = () => (
  <div className="flex flex-row lg:flex-col flex-wrap justify-end items-end flex-1-1-30">
    <Link className="link p-2 uppercase" to="/about">
      About
    </Link>
    <Link className="link ml-2 p-2 uppercase" to="/posts">
      Thought
    </Link>
    <Link className="link ml-2 p-2 uppercase" to="/works">
      Work
    </Link>
    <a
      className="button mt-2 ml-2"
      href="mailto:max8hine@gmail.com?subject=Let's catch up&body=Hi Max,%0D%0A"
    >
      Talk
    </a>
  </div>
)

const WhoAmI = () => (
  <div className="text-6xl lg:text-7xl uppercase  flex-1-1-70">
    <span className="font-heading">Max</span>
    <span className="font-thin">Ma</span>
  </div>
)

const IndexPage = ({ location }) => {
  return (
    <Layout location={location}>
      <Hero></Hero>
      <div className="fixed top-0 left-0 h-screen w-screen touch-none noselect flex justify-center items-center md:justify-end">
        <div className="home-card">
          <Tilt
            className="shadow-xl w-full h-full bg-baby-powder z-10"
            gyroscope
          >
            <div className="h-full px-8 py-16 flex flex-col justify-between">
              <WhoAmI></WhoAmI>
              <Menu></Menu>
            </div>
          </Tilt>
        </div>
      </div>
    </Layout>
  )
}

IndexPage.propTypes = {
  location: PropTypes.object.isRequired,
}

export default IndexPage
